module.exports = __webpack_public_path__ + "static/media/gyro-demo.8f44233f.gif";